import { ApiReorderDetailsItemResponse, ApiReorderDetailsResponse } from 'src/app/core/models';
import { reorders } from './order.mock';

const findReorder = (id?: number): ApiReorderDetailsResponse[] | null => {
  if (!id) return null;

  const reorder = reorders.find((o) => o.id === id);

  if (!reorder) return null;

  return [
    {
      referenceNo: reorder.id,
      items: reorder.items as ApiReorderDetailsItemResponse[],
      shipmentDate: reorder.reorderServiceDate,
      shipmentTypeId: reorder.shipmentTypeId,
    },
  ];
};

export const getReorderDetails = (urlParams: any): ApiReorderDetailsResponse[] | null => {
  const reorderId = parseInt(urlParams?.reorderId);
  return findReorder(reorderId);
};

export const getShipmentDetails = (urlParams: any): ApiReorderDetailsResponse[] | null => {
  const shipmentId = parseInt(urlParams?.shipmentId);
  return findReorder(shipmentId);
};
